import {
    getIsApiPending,
    getAccessToken,
    getStatusApiCallStatus,
    getStkRequestId,
    getPaymentMode,
} from '../../../selectors/travelUg/payments';

import {
    apiTransitionStkPush,
    apiTransitionPaymentsStatus,
    triggerPaymentsStkPushSuccess,
    checkPaymentsStatusSuccess,
    checkPaymentsStatus,
} from '../../../actions/travelUg/payments';
import axios from 'axios';
import { getIsApiPaymentStatusPending } from '../../../selectors/roaCarInsurance/payments';
import { setExpiredAuth } from '../../../actions/travelUg/quote';
import { orderConfirmationService } from './orderConfirmation';
import { makePaymentSubmission } from './submitPaymentData';

let intervalId = null;

const clearIntervalId = () => {
    if (intervalId) {
        clearInterval(intervalId);
        intervalId = null;
    }
};

export const paymentsStkService = async (store, next, action) => {
    const state = store.getState();

    if (getIsApiPending(state)) {
        return next(action);
    }

    store.dispatch(apiTransitionStkPush.pending());

    try {
        //const resp = await store.dispatch(submitPaymentFormData());

        const modeOfPayment = getPaymentMode(state);

        const resp = await makePaymentSubmission(state, store, modeOfPayment);
        store.dispatch(triggerPaymentsStkPushSuccess(resp.data));
        store.dispatch(apiTransitionStkPush.success());

        intervalId = setInterval(async () => {
            store.dispatch(checkPaymentsStatus());

            if (getStatusApiCallStatus(store.getState()) === 'success') {
                clearIntervalId();
            }
        }, 20000);

        setTimeout(() => {
            if (getStatusApiCallStatus(store.getState()) !== 'success') {
                clearIntervalId();
                store.dispatch(apiTransitionPaymentsStatus.failure());
            }
        }, 140000);
    } catch (error) {
        store.dispatch(apiTransitionStkPush.failure());
        console.error(error);
    }

    return next(action);
};

export const paymentsStkStatusService = async (store, next, action) => {
    const state = store.getState();

    if (getStatusApiCallStatus(state) === 'success') {
        clearIntervalId();
        return next(action);
    }

    if (getIsApiPaymentStatusPending(state)) {
        return next(action);
    }

    store.dispatch(apiTransitionPaymentsStatus.pending());

    try {
        const resp = await triggerStkStatusCheck(state);

        if (resp?.data?.statusCode === '00') {
            clearIntervalId();
            store.dispatch(checkPaymentsStatusSuccess(resp.data));
            store.dispatch(apiTransitionPaymentsStatus.success());

            //store.dispatch(triggerConfirmOrder());
            await orderConfirmationService(store, next, action);
        }
    } catch (error) {
        if (error?.response?.data?.status === 401 || error?.response?.data?.status === 403) {
            store.dispatch(setExpiredAuth(true));
        }
        console.error(error);
    }

    return next(action);
};

const stkStatusPayload = (state) => {
    const requestId = getStkRequestId(state);

    return {
        requestId,
        sourceSystem: 'FLEXIPAY',
    };
};

const triggerStkStatusCheck = async (state) => {
    const loginData = getAccessToken(state);
    const url = '/om-api/travel-ug/payments/stk/status';

    try {
        return await axios.post(url, stkStatusPayload(state), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
            },
        });
    } catch (error) {
        console.error(error);
        throw error;
    }
};

/*
function getCurrentTimestamp() {
    const now = new Date();
    const day = String(now.getDate()).padStart(2, '0');
    const month = String(now.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const year = now.getFullYear();
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
    const timestamp = `${day}${month}${year}${hours}${minutes}${seconds}`;
    return timestamp;
}

function formatPhoneNumber(phoneNumber, countryCode) {
    const cleanedNumber = phoneNumber.substring(1);
    const formattedNumber = `${countryCode}${cleanedNumber}`;

    return formattedNumber;
}

const stkPushPayload = (state) => {
    const paymentsData = getPaymentsForm(state);
    const premium = getUgxPremium(state);
    const requestId = getCurrentTimestamp();
    const msisdn = formatPhoneNumber(paymentsData.phoneNumber.value, '256');
    const networkProvider = paymentsData.networkProvider.value;

    const payload = {
        msisdn: msisdn,
        amount: premium.toString(),
        sourceSystem: networkProvider,
        narrative: 'Travel Insurance',
        requestId: requestId,
        referenceNumber: requestId,
    };

    return {
        ...payload,
    };
};

const triggerStkPush = async (state) => {
    const loginData = getAccessToken(state);
    try {
        const url = '/om-api/travel-ug/payments/stk';
        return await axios.post(url, stkPushPayload(state), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
            },
        });
    } catch (e) {
        store.dispatch(triggerPaymentsStkPushFailure(e?.response?.data || {}));
        throw e;
    }
};

*/
